import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useApi } from '@/utils/axios';
import { CLIENTE_ROTAS } from '@/utils/apiRoutes';

export const useClienteStore = defineStore('cliente', () => {
  const cliente = ref(null);
  const loading = ref(false);
  const error = ref(null);

  // Buscar cliente por telefone
  const buscarClientePorTelefone = async (telefone) => {
    if (!telefone) return null;
    
    if (telefone.length < 10) {
      error.value = "O telefone deve ter pelo menos 10 dígitos";
      return null;
    }

    loading.value = true;
    error.value = null;

    try {
      const response = await useApi(CLIENTE_ROTAS.BUSCAR_POR_TELEFONE(telefone)).fetch();
      
      if (response?.data) {
        cliente.value = response.data;
        return response.data;
      } else {
        throw new Error('Cliente não encontrado');
      }
    } catch (err) {
      error.value = err.message || 'Erro ao buscar cliente';
      console.error('Erro ao buscar cliente:', err);
      cliente.value = null;
      return null;
    } finally {
      loading.value = false;
    }
  };

  // Limpar os dados do cliente
  const limparCliente = () => {
    cliente.value = null;
    error.value = null;
  };

  const limparErros = () => {
    error.value = null;
  };

  // Formatar data para exibição
  const formatarData = (dataString) => {
    if (!dataString) return 'N/A';
    
    try {
      const data = new Date(dataString);
      return data.toLocaleDateString('pt-BR');
    } catch (err) {
      return 'N/A';
    }
  };

  // Formatar endereço completo
  const formatarEnderecoCompleto = (cliente) => {
    if (!cliente) return '';
    
    const { logradouro, numero, complemento, bairro, cidade, estado, cep } = cliente;
    
    let endereco = logradouro || '';
    if (numero) endereco += `, ${numero}`;
    if (complemento) endereco += ` - ${complemento}`;
    if (bairro) endereco += ` - ${bairro}`;
    if (cidade) endereco += `, ${cidade}`;
    if (estado) endereco += `/${estado}`;
    if (cep) endereco += ` - CEP: ${cep}`;
    
    return endereco || 'Endereço não informado';
  };

  // Formatar pedidos em aberto para exibição
  const formatarPedidosAbertos = (cliente) => {
    if (!cliente || !cliente.tem_pedido_aberto || !cliente.pedidos_abertos || cliente.pedidos_abertos.length === 0) {
      return null;
    }
    
    return {
      quantidade: cliente.pedidos_abertos.length,
      lista: cliente.pedidos_abertos
    };
  };

  // Verificar se o cliente tem pedidos em aberto
  const temPedidosAbertos = () => {
    return cliente.value && 
           cliente.value.tem_pedido_aberto === true && 
           cliente.value.pedidos_abertos && 
           cliente.value.pedidos_abertos.length > 0;
  };

  return {
    cliente,
    loading,
    error,
    buscarClientePorTelefone,
    limparCliente,
    limparErros,
    formatarData,
    formatarEnderecoCompleto,
    formatarPedidosAbertos,
    temPedidosAbertos
  };
});
